import { graphql, useStaticQuery, Link } from "gatsby";
import React, { useState } from "react";
import { GatsbyImage } from "gatsby-plugin-image";
import Grid, { Col } from "../grid/Grid";
import Section from "../section/Section";
import AppLink from "../appLink/AppLink";
import IconNewArrow from "../../assets/IconNewArrow";
import * as styles from "./PackagesBlock.module.css";

const PackagesBlock = ({ showLink }) => {
  const { discover, pilot, launch, boost } = useStaticQuery(graphql`
    query {
      discover: mdx(frontmatter: { name: { eq: "discover" } }) {
        ...PageDefault
        frontmatter {
          subtitle
        }
      }
      pilot: mdx(frontmatter: { name: { eq: "pilot" } }) {
        ...PageDefault
        frontmatter {
          subtitle
        }
      }
      launch: mdx(frontmatter: { name: { eq: "launch" } }) {
        ...PageDefault
        frontmatter {
          subtitle
        }
      }
      boost: mdx(frontmatter: { name: { eq: "boost" } }) {
        ...PageDefault
        frontmatter {
          subtitle
        }
      }
    }
  `);
  const packages = [discover, pilot, launch, boost];

  const [activeItem, setActiveItem] = useState("discover");
  const [focusedItem, setFocusedItem] = useState(null);
  
  const handleMouseEnter = (itemName) => {
    if (!focusedItem) {
      setActiveItem(itemName);
    }
  };
  
  const handleMouseLeave = () => {
    if (!focusedItem) {
      setActiveItem("discover");
    }
  };
  
  const handleFocus = (itemName) => {
    setFocusedItem(itemName);
    setActiveItem(itemName);
  };
  
  const handleBlur = (e) => {
    if (!e.currentTarget.contains(e.relatedTarget)) {
      setFocusedItem(null);
      setActiveItem("discover");
    }
  };
  
  const renderRows = packages.map(item => (
    <li key={item.frontmatter.name}>
      <Link
        to={item.frontmatter.path}
        onMouseEnter={() => handleMouseEnter(item.frontmatter.name)}
        onMouseLeave={handleMouseLeave}
        onFocus={() => handleFocus(item.frontmatter.name)}
        onBlur={handleBlur}
        className={`${styles.link} ${styles[item.frontmatter.name]}`}
        data-cabin-event={`Home-to-${item.frontmatter.name}`}
        onClick={() => window.rybbit?.event(`Home to ${item.frontmatter.name.charAt(0).toUpperCase() + item.frontmatter.name.slice(1)}`)}
      >
        <Grid verticalCenter className={styles.hitArea}>
          <Col start={1} span={5}>
            <div className={styles.arrow}><IconNewArrow /></div>
            <h2 className={`h1 h1EvenBigger ${styles.title}`}>{item.frontmatter.title}</h2>
          </Col>
        </Grid>
        <Grid className={styles.content}>
          <Col start={8} span={5}>
            <p className={`largestBodyText ${styles.tagline}`}>{item.frontmatter.tagline}</p>
            <div className={styles.imageWrapper}>
              <GatsbyImage image={item.thumbnail.childImageSharp.gatsbyImageData} alt="" className={`${styles.image} borderRadius`} />
            </div>
            <p className={`smallestBodyText textAlignRight textMarginTop ${styles.thumbnailAlt}`}>{item.frontmatter.thumbnailAlt}</p>
            <div className={styles.mobileArrow}><IconNewArrow /></div>
          </Col>
        </Grid>
      </Link>
    </li>
  ));
  
  return (
    <Section padding="both" className={`${styles.container} ${styles[`${activeItem}Active`]}`} noInner>
      <Grid verticalCenter className={`${styles.header} textMarginBottomLarge`}>
        <h2 className="noMargin"><Link to="/what-we-do/">What we do</Link></h2>
      </Grid>
      <div>
        <ul className={`${styles.packages}`}>
          {renderRows}
        </ul>
      </div>
    </Section>
  );
  
};

export default PackagesBlock;
